module.exports = __webpack_public_path__ + "static/img/fix-1.da90bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/fix-1.jpg
// module id = SJ2g
// module chunks = 1